import { YesObject } from '@yes.technology/react-toolkit'

import { ExecutionState } from 'workflow/shared/types/workflow.type'

export default function getOutputNode(
  taskUuid: string | undefined,
  processToken?: YesObject
) {
  if (!processToken || !taskUuid) return null

  let executionState: ExecutionState
  try {
    executionState = JSON.parse(processToken.execution_state as string)
  } catch (e) {
    executionState = {} as ExecutionState
  }

  const nodemodels = Object.fromEntries(
    (executionState.flow_elementmodels?.nodemodels ?? []).map((nodemodel) => [
      nodemodel.uuid,
      nodemodel
    ])
  )

  return nodemodels?.[taskUuid]
}
